import React, { useEffect, useState } from "react";
import "./switch-dashboard-main.css";
import "./select-dashboards-modal.css";
import SelectDashboard1 from "../../components/newly-components/SelectDashboard1";
import SelectDashboard2 from "../../components/newly-components/SelectDashboard2";
import SelectDashboard3 from "../../components/newly-components/SelectDashboard3";
import { useTheme } from "../../utils/ThemeContext";

const SelectDashboardComponentsModal = ({
  setarrrrrrrSet,
  setarrrrrrrSet2,
  setOriginalSetting,
  setUnselectTitles1,
  setUnselectTitles2,
  setUnselectTitles3,
  compareFilterDashboard,
  originalSettings,
  setSelectedTitlesForDashboard3,
  setSelectedTitlesForDashboard1,
  setSelectedTitlesForDashboard2,
}) => {
  const [compareFilter, setCompareFilter] = useState("Financial Dashboard 1");
  const { theme } = useTheme();
  const [dashboardFilter,setDashboardFilter]=useState([
    { id: 1, filter: "Dashboard 1", component: "SavedDashboard1" },
    { id: 2, filter: "Dashboard 2", component: "SavedDashboard2" },
    { id: 3, filter: "Dashboard 3", component: "SavedDashboard3" },
  ]);
  const currentDashboard = dashboardFilter && dashboardFilter.find(dashboard => dashboard.filter === compareFilter);

  useEffect(() => {
    // if (compareFilterDashboard === "Dashboard 1") {
    //   setCompareFilter("Financial Dashboard 1");
    // }
    // if (compareFilterDashboard === "Dashboard 2") {
    //   setCompareFilter("Financial Dashboard 2");
    // }
    // if (compareFilterDashboard === "Dashboard 3") {
    //   setCompareFilter("Financial Dashboard 3");
    // }
    setCompareFilter(compareFilterDashboard);
  }, [compareFilterDashboard]);
  useEffect(() => {
    if(originalSettings.dashboardNames){
      const updatedFilters = originalSettings.dashboardNames && originalSettings.dashboardNames.map((dashboard, index) => ({
        id: index + 1,
        filter: dashboard.name || `Dashboard ${index + 1}`,
        component:`SavedDashboard${index + 1}`,
      }));

      setDashboardFilter(updatedFilters);
      // const firstDashboard = originalSettings.dashboardNames && originalSettings.dashboardNames.find(
      //   (dashboard) => dashboard.key === "dashboard1"
      // );
      // if (firstDashboard) {
      //   setCompareFilter(firstDashboard.name);
      // }
    }
  }, [originalSettings]);

  const handleSelect = (filter) => {
    setCompareFilter(filter);
  };

  const handleCardSelectDashboard1 = (title, isSelected) => {
    setSelectedTitlesForDashboard1((prevTitles) => {
      const updatedTitles = isSelected
        ? [...prevTitles, { id: title }]
        : prevTitles.filter((item) => item.id !== title);

      return [...new Set(updatedTitles)];
    });

    setUnselectTitles1((prevUnselected) => {
      if (!isSelected) {
        return [...new Set([...prevUnselected, title])];
      } else {
        return prevUnselected.filter(
          (unselectTitle) => unselectTitle !== title
        );
      }
    });
  };

  const handleCardSelectDashboard2 = (title, isSelected) => {
    setSelectedTitlesForDashboard2((prevTitles) => {
      const updatedTitles = isSelected
        ? [...prevTitles, { id: title }]
        : prevTitles.filter((item) => item.id !== title);

      return [...new Set(updatedTitles)];
    });

    setUnselectTitles2((prevUnselected) => {
      if (!isSelected) {
        return [...new Set([...prevUnselected, title])];
      } else {
        return prevUnselected.filter(
          (unselectTitle) => unselectTitle !== title
        );
      }
    });
  };

  const handleCardSelectDashboard3 = (title, isSelected) => {
    setSelectedTitlesForDashboard3((prevTitles) => {
      const updatedTitles = isSelected
        ? [...prevTitles, { id: title }]
        : prevTitles.filter((item) => item.id !== title);

      return [...new Set(updatedTitles)];
    });

    setUnselectTitles3((prevUnselected) => {
      if (!isSelected) {
        return [...new Set([...prevUnselected, title])];
      } else {
        return prevUnselected.filter(
          (unselectTitle) => unselectTitle !== title
        );
      }
    });
  };
   const renderDashboardComponent = (filter) => {
      switch (filter) {
        case "SavedDashboard1":
          return (
            <SelectDashboard1
            theme={theme}
            setOriginalSetting={setOriginalSetting}
            originalSettings={originalSettings}
            handleCardSelectDashboard1={handleCardSelectDashboard1}
          />
          );
        case "SavedDashboard2":
          return (
            <SelectDashboard2
            theme={theme}
            originalSettings={originalSettings}
            handleCardSelectDashboard2={handleCardSelectDashboard2}
          />
          );
        case "SavedDashboard3":
          return (
            <SelectDashboard3
            theme={theme}
            originalSettings={originalSettings}
            handleCardSelectDashboard3={handleCardSelectDashboard3}
          />
          );
        default:
          return null; // Handle the case where no dashboard matches
      }
    };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "rgb(35, 35, 35)" : "#ffffff",
      }}
      className="select-dashboard-modal-main-container">
      <div
        className="compareSelectContainer"
        style={{ display: "flex", justifyContent: "flex-end" }}>
        <div className="compareSelect">
          {dashboardFilter.map((item) => (
            <div
              key={item.id}
              className={
                item.filter === compareFilter
                  ? "selectedfilter"
                  : "unSelectedfilter"
              }
              onClick={() => handleSelect(item.filter)} title={item.filter && item.filter}>
              {item.filter && item.filter.length > 23 ? `${item.filter.slice(0, 20)}...` : item.filter}
            </div>
          ))}
        </div>
      </div>
      <div>
      {currentDashboard && renderDashboardComponent(currentDashboard.component)}
      </div>
     {/* <div>
        {compareFilter === "Financial Dashboard 1" && (
          <SelectDashboard1
            theme={theme}
            setOriginalSetting={setOriginalSetting}
            originalSettings={originalSettings}
            handleCardSelectDashboard1={handleCardSelectDashboard1}
          />
        )}
        {compareFilter === "Financial Dashboard 2" && (
          <SelectDashboard2
            theme={theme}
            originalSettings={originalSettings}
            handleCardSelectDashboard2={handleCardSelectDashboard2}
          />
        )}
        {compareFilter === "Financial Dashboard 3" && (
          <SelectDashboard3
            theme={theme}
            originalSettings={originalSettings}
            handleCardSelectDashboard3={handleCardSelectDashboard3}
          />
        )}
      </div> */}
    </div>
  );
};

export default SelectDashboardComponentsModal;
